import { vimeoApi } from '@gik/core/api';

export async function getVimeoThumbnailUrl(videoLink: string): Promise<string> {
  try {
    const result = await vimeoApi(`oembed.json?url=${videoLink}`);
    return (await result.json()).thumbnail_url;
  } catch (e) {
    return null;
  }
}
